import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import UsersPage from "../pages/Users/UsersPage"
import OrdersPage from "../pages/Orders/OrdersPage"
import SettingsPage from "../pages/Settings/SettingsPage"
import OrderDetailsPage from "../pages/Orders/OrderDetailsPage"
import CreateExchangeOrderPage from "../pages/Orders/CreateExchangeOrderPage"
import OfficeExpensesPage from "../pages/OfficeExpenses/OfficeExpensesPage"
import BalanceAdvancesPage from "../pages/BalanceAdvances/BalanceAdvancesPage"

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  {path:"/users", component: <UsersPage /> },
  {path:"/orders", component: <OrdersPage /> },
  { path: "/orders/:orderId", component: <OrderDetailsPage /> },
  { path: "/create-exchange-order", component: <CreateExchangeOrderPage /> },
  { path: "/office-expenses", component: <OfficeExpensesPage /> },
  { path: "/balance-advances", component: <BalanceAdvancesPage /> },

  // //profile
  { path: "/settings", component: <SettingsPage /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
];

export { authProtectedRoutes, publicRoutes };
